import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {AddressModel, Country, CountryService, PostalCodeService} from '../../api';

@Component({
    selector: 'app-edit-customer-address',
    templateUrl: './edit-customer-address.component.html',
    standalone: false
})
export class EditCustomerAddressComponent implements OnInit {
  @Input() Address: FormGroup;

  readonly requiredValidator = Validators.required;
  countries: Array<Country> = null;
  validationMessages = {};

  constructor(private countryService: CountryService,
              private postalcodeService: PostalCodeService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.countryService.listAllCountries().subscribe((countries) => {
      // Get translated strings
      countries.map(c => c.Name = this.translate.instant(`COUNTRY.${c.Iso2}`));

      // Sort by prio and alphabetically
      this.countries = countries.sort((c1, c2) => {
        const prio1 = c1.Priority || 0;
        const prio2 = c2.Priority || 0;
        if (prio2 - prio1 !== 0)
          return (prio2 - prio1);

        // Remove non-letters from the names
        const name1 = c1.Name.replace(/[^a-z]/gi, '');
        const name2 = c2.Name.replace(/[^a-z]/gi, '');
        return (name1 < name2) ? -1 : (name1 > name2) ? 1 : 0;
      });
    });
  }

  checkPostalCode(forceCheck: boolean) {
    const postalcode = this.Address['controls'].PostalCode;
    const streetNr = this.Address['controls'].StreetNr;
    const addition = this.Address['controls'].StreetNrAddition;
    const doCall = ((postalcode.value && streetNr.value) && (postalcode.valid && streetNr.valid) && (postalcode.dirty || streetNr.dirty));

    if (doCall || forceCheck) {
      this.postalcodeService.checkPostalCode(postalcode.value, streetNr.value.toString(), addition?.value?.toString() ?? "").subscribe((address: AddressModel) => {
        if (address != null) {
          this.Address.patchValue(address);
        }
      });
    }
  }
}
